export default __webpack_public_path__ + "static/media/txt_h5.fb76429b.svg";